import React from 'react';
import Section from '@atoms/Section/Section';
import Title from '@atoms/Title/Title';
import TitleGroup from '@atoms/TitleGroup/TitleGroup';
import Module from '@atoms/Module/Module';
import CardSlider from '@components/CardSlider/CardSlider';
import { Box } from '@material-ui/core';
import Icon from '@atoms/Icon/Icon';
import { SwiperSlide } from 'swiper/react';
import { FaArrowRight } from 'react-icons/fa';
import './RelatedContent.scss';

const RelatedContent = ({ title, cards }) => {
    return (
        <>
            <Section spacing="m" container="large" className="RelatedContent">
                <TitleGroup title={title} />
                <CardSlider
                    sliderName="RelatedContent"
                    hideOverflow
                    hasNavigation
                    sliderOption={{
                        autoHeight: true,
                        observer: true,
                        observeParents: true,
                        slideToClickedSlide: true,
                        slidesPerView: 1.3,
                        a11y: false,
                        preventClicksPropagation: true,
                        threshold: 20,
                        breakpoints: {
                            slidesOffsetAfter: 20,
                            slidesOffsetBefore: 20,
                            501: {
                                slidesPerView: 1.3,
                                spaceBetween: 16,
                            },
                            801: {
                                slidesPerView: 2.3,
                                spaceBetween: 16,
                            },
                            1001: {
                                slidesPerView: 3.3,
                            },
                        },
                    }}
                >
                    {cards?.map((item) => (
                        <SwiperSlide key={item.label}>
                            <a href={item.to} target="_blank">
                                <div className="RelatedContent--card">
                                    <Module radius="giant" spacing="m">
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            flexDirection="column"
                                            sx={{ height: '300px' }}
                                        >
                                            <Title size="l" theme="soft">
                                                {item.label}
                                            </Title>
                                            <Icon
                                                size="s"
                                                theme="white"
                                                icon={<FaArrowRight />}
                                            />
                                        </Box>
                                    </Module>
                                </div>
                            </a>
                        </SwiperSlide>
                    ))}
                </CardSlider>
            </Section>
        </>
    );
};

export default RelatedContent;
